import { track, trackThenNavigate } from "utils/analytics"
import observeTouchpointExposure from "utils/touchpoint-exposure"

export default function initSnowmailTracking(root: ParentNode = document): void {
  if (window.FCGON?.is_app) return

  root.querySelectorAll<HTMLAnchorElement>('a[data-touchpoint^="snowmail_"]').forEach((link) => {
    if (link.dataset.snowmailTrackingInitialized) return
    link.setAttribute("data-snowmail-tracking-initialized", "true")

    link.addEventListener("click", (event) => {
      if (event.defaultPrevented || event.button !== 0) return

      const params = { touchpoint: link.dataset.touchpoint }
      if (
        event.ctrlKey ||
        event.metaKey ||
        event.shiftKey ||
        event.altKey ||
        link.target === "_blank"
      ) {
        track("touchpoint_click", params)
        return
      }

      event.preventDefault()
      trackThenNavigate("touchpoint_click", params, () => window.location.assign(link.href))
    })

    link.addEventListener("auxclick", (event) => {
      if (!event.defaultPrevented && event.button === 1) {
        track("touchpoint_click", { touchpoint: link.dataset.touchpoint })
      }
    })
  })

  observeTouchpointExposure(root)
}
